module.exports = {
    request: {
        timeout: 30000,
        maxRetryError: 5,
    },
    api: {
        // auth: 'http://localhost:3176/api/v1/'
        auth: 'https://h41.cnnd.vn/auth-api/'
    }
};